import { dynamicFailed } from "../hooks/useToast";
import { INotice } from "../exports/interfaces";
import axiosClient from "../axioxClient.ts/axiosClient";

export const fetchNotices = async (): Promise<INotice[]> => {
   try {
    const response = await axiosClient.get<INotice[]>(
      `/notices`,
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
    return [];
  }
};
